<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<v-row>
			<v-col cols="12" md="4">
				<label-personalizado
					nome-campo="Tipo"
					:obrigatorio-por-padrao="!visualizacao"
					:apresenta-tooltip="!!idExternoModeloDocumento"
					mensagem-padrao-tooltip="Não é possível editar este campo, pois existe um modelo de documento adicionado."
				></label-personalizado>
				<v-text-field
					v-model="tipo"
					maxlength="20"
					counter="20"
					type="string"
					placeholder="Informe o tipo"
					:rules="tipoRules"
					:disabled="visualizacao || !!idExternoModeloDocumento"
				></v-text-field>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Assinatura Automática"></label-personalizado>
				<v-radio-group row v-model="assinaturaAutomatica" :disabled="visualizacao">
					<v-radio label="Sim" value="SIM"></v-radio>
					<v-radio label="Não" value="NAO"></v-radio>
				</v-radio-group>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Juntar Automático"></label-personalizado>
				<v-radio-group row v-model="juntarAutomatico" :disabled="visualizacao">
					<v-radio label="Sim" value="SIM"></v-radio>
					<v-radio label="Não" value="NAO"></v-radio>
				</v-radio-group>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Fluxo" :obrigatorio-por-padrao="!visualizacao"></label-personalizado>
				<v-autocomplete
					v-model="tipoEntidade"
					:items="tiposEntidadeRevisao"
					:rules="tipoEntidadeRules"
					placeholder="Selecione"
					clearable
					item-text="nome"
					item-value="tipo"
					@input="onSelectTipoEntidade"
					:disabled="visualizacao || !!idExternoModeloDocumento"
				></v-autocomplete>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado
					nome-campo="Atividade"
					:obrigatorio-por-padrao="!visualizacao"
				></label-personalizado>
				<v-autocomplete
					v-model="atividade"
					:items="atividadeDatasource"
					:rules="atividadeRules"
					placeholder="Selecione"
					clearable
					item-text="nomeAtividade"
					item-value="idAtividade"
					return-object
					@input="onSelectAtividadeFluxo"
					:disabled="!tipoEntidade || visualizacao"
				></v-autocomplete>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Perfil" :obrigatorio-por-padrao="!visualizacao"></label-personalizado>
				<v-autocomplete
					v-model="perfil"
					:items="perfilDatasource"
					:rules="perfilRules"
					placeholder="Selecione"
					clearable
					:disabled="!atividade || visualizacao"
					item-text="nome"
					item-value="id"
					return-object
				></v-autocomplete>
			</v-col>
		</v-row>
		<v-row class="align-center">
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Encaminhamento Automático"></label-personalizado>
				<v-radio-group row v-model="encaminhamentoAutomatico" :disabled="visualizacao">
					<v-radio label="Sim" value="SIM"></v-radio>
					<v-radio label="Não" value="NAO"></v-radio>
				</v-radio-group>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado
					nome-campo="Atividade Encaminhamento"
					:obrigatorio-por-padrao="ehEncaminhamentoAutomatico && !visualizacao"
					:apresenta-tooltip="!ehEncaminhamentoAutomatico && !visualizacao"
					mensagem-padrao-tooltip="Só é permitido informar a atividade de encaminhamento quando a opção de encaminhamento automático for 'Sim'"
				></label-personalizado>
				<v-autocomplete
					v-model="atividadeEncaminhamento"
					:items="atividadeEncaminhamentoDatasource"
					:rules="atividadeEncaminhamentoRules"
					placeholder="Selecione"
					:disabled="!ehEncaminhamentoAutomatico || visualizacao"
					clearable
					item-value="id"
					item-text="nome"
					return-object
				></v-autocomplete>
			</v-col>
			<v-col cols="12" md="4" v-if="!visualizacao" class="pb-0">
				<botao-primario
					id="salvarRevisaoBtn"
					nome-botao="Salvar"
					@click="salvarRevisao"
					:disabled="desabilitarBotaoSalvar"
				></botao-primario>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="4">
				<botao-primario
					id="adicionarModeloBtn"
					nome-botao="Adicionar Modelo"
					icone="mdi-plus-circle"
					:disabled="!idRevisao || !!idExternoModeloDocumento || visualizacao"
					@click="abrirFecharModalModeloDocumentoRevisao"
				></botao-primario>
				<tooltip-informativo
					v-if="!idRevisao || !!idExternoModeloDocumento"
					:mensagem-padrao-tooltip="mensagemTooltip"
				></tooltip-informativo>
			</v-col>
		</v-row>
		<v-row v-if="!!idExternoModeloDocumento">
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Tipo"></label-personalizado>
				<v-text-field :value="tipoDocumento" disabled counter="20" maxlength="20"></v-text-field>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado nome-campo="Título"></label-personalizado>
				<v-text-field :value="tituloDocumento" disabled counter="50" maxlength="50"></v-text-field>
			</v-col>
			<v-col cols="12" md="4">
				<label-personalizado class="text-center" nome-campo="Ações"></label-personalizado>
				<modelo-documento-revisao-botoes-acoes
					:visualizacao="visualizacao"
					@redigir="redigirModeloDocumentoRevisao"
					@visualizar="visualizarModeloDocumentoRevisao"
					@excluir="abrirOuFecharModalConfirmacaoExcluirModelo"
				></modelo-documento-revisao-botoes-acoes>
			</v-col>
		</v-row>
		<v-row justify="end" v-if="podeFinalizarRevisao">
			<v-col cols="12" md="4" class="d-flex justify-md-end">
				<botao-primario nome-botao="Aplicar em fluxo" @click="finalizarRevisao"></botao-primario>
			</v-col>
		</v-row>

		<modal-modelo-documento-revisao
			v-if="exibirModalModeloDocumentoRevisao"
			:exibir="exibirModalModeloDocumentoRevisao"
			:tipo-documento="tipo"
			titulo-modal="Adicionar Modelo de Documento"
			@fechar-modal="abrirFecharModalModeloDocumentoRevisao"
			@salvar-modelo-documento-revisao="salvarModeloDocumentoRevisao"
		></modal-modelo-documento-revisao>

		<modal-confirmacao
			:exibir="exibirModalConfirmacaoExcluirModelo"
			titulo-modal="Deseja excluir esse modelo?"
			subtitulo-modal="Após a confirmação você não poderá recuperar este modelo!"
			mensagem="Deseja realmente confirmar esta ação?"
			@fechar-modal="abrirOuFecharModalConfirmacaoExcluirModelo"
			@confirmar="excluirModeloDocumentoRevisao"
		></modal-confirmacao>
	</v-form>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { actionTypes, routesNames, situacoesRevisao } from '@/core/constants'
import TooltipInformativo from '@/views/components/TooltipInformativo.vue'
import ModalModeloDocumentoRevisao from '@/views/pages/configuracao/revisoes/formulario-revisao/modal-modelo-documento/ModalModeloDocumentoRevisao.vue'
import documentoMixin from '@/views/mixins/documento'
import ModeloDocumentoRevisaoBotoesAcoes from '@/views/pages/configuracao/revisoes/formulario-revisao/botoes-acoes/ModeloDocumentoRevisaoBotoesAcoes.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'formulario-revisao',
	components: {
		ModalConfirmacao,
		ModeloDocumentoRevisaoBotoesAcoes,
		ModalModeloDocumentoRevisao,
		TooltipInformativo,
		BotaoPrimario,
		LabelPersonalizado,
	},
	mixins: [documentoMixin, validacaoFormulario],
	props: {
		idRevisao: {
			type: Number,
			default: null,
		},
		visualizacao: Boolean,
		funcaoSalvarRevisao: {
			type: Function,
			required: false,
			default: () => {
				return Promise.resolve()
			},
		},
	},
	emits: ['salvar-revisao'],
	data() {
		return {
			isFormValid: false,
			exibirModalModeloDocumentoRevisao: false,
			tipo: null,
			tipoRules: [
				(v) => this.regraObrigatoriedade(v, 'Tipo é obrigatório.'),
				(v) =>
					this.regraDeTamanhoMaximoString(
						v,
						20,
						'O campo tipo deve ser menor ou igual do que 20 caracteres.',
					),
			],
			assinaturaAutomatica: 'NAO',
			juntarAutomatico: 'NAO',
			tiposEntidadeRevisao: [
				{
					nome: 'Adesão',
					tipo: 'ADESAO',
				},
				{
					nome: 'Adesão Externa',
					tipo: 'ADESAO_EXTERNA',
				},
				{
					nome: 'Pedido Utilização',
					tipo: 'PEDIDO_UTILIZACAO',
				},
			],
			tipoEntidade: null,
			tipoEntidadeRules: [(v) => this.regraObrigatoriedade(v, 'Fluxo é obrigatório.')],
			atividade: null,
			atividadeRules: [(v) => this.regraObrigatoriedade(v, 'Atividade é obrigatória.')],
			atividadeDatasource: [],
			perfil: null,
			perfilRules: [(v) => this.regraObrigatoriedade(v, 'Perfil é obrigatório.')],
			perfilDatasource: [],
			exibirModalConfirmacaoExcluirModelo: false,
			encaminhamentoAutomatico: 'NAO',
			atividadeEncaminhamento: null,
			atividadeEncaminhamentoDatasource: [],
			idExternoModeloDocumento: null,
			tipoDocumento: null,
			tituloDocumento: null,
			situacao: null,
		}
	},
	computed: {
		ehEncaminhamentoAutomatico() {
			return this.encaminhamentoAutomatico === 'SIM'
		},
		atividadeEncaminhamentoRules() {
			return this.ehEncaminhamentoAutomatico
				? [(v) => this.regraObrigatoriedade(v, 'Atividade Encaminhamento é obrigatória.')]
				: []
		},
		processKey() {
			const processKeyPorEntidades = {
				ADESAO: this.$store.state.parametrosSistema.adesaoProcessKey,
				ADESAO_EXTERNA: this.$store.state.parametrosSistema.adesaoExternaProcessKey,
				PEDIDO_UTILIZACAO: this.$store.state.parametrosSistema.processoUtilizacaoProcessKey,
			}
			return processKeyPorEntidades[this.tipoEntidade]
		},
		desabilitarBotaoSalvar() {
			return !this.isFormValid
		},
		mensagemTooltip() {
			if (!this.idRevisao) {
				return 'A revisão deve ser salva primeiro para poder adicionar um modelo de documento.'
			}
			return 'Não é possível incluir mais de um modelo de documento para revisão.'
		},
		podeFinalizarRevisao() {
			return this.situacao !== situacoesRevisao.FINALIZADO.value && this.idExternoModeloDocumento !== null
		},
	},
	watch: {
		encaminhamentoAutomatico(novoValor) {
			if (novoValor === 'NAO') this.atividadeEncaminhamento = null
		},
	},
	async mounted() {
		await this.buscarAtividadesFluxo()

		if (this.idRevisao) {
			await this.buscarRevisaoPorId()

			if (this.atividade !== null) await this.onSelectAtividadeFluxo()
		}
	},
	methods: {
		async setFormRevisao(revisao) {
			this.tipo = revisao.tipo
			this.assinaturaAutomatica = revisao.assinaturaAutomatica
			this.juntarAutomatico = revisao.juntarAutomatico
			this.tipoEntidade = revisao.tipoEntidade

			await this.buscarAtividadesFluxo()

			this.atividade = {
				idAtividade: revisao.idAtividade,
				nomeAtividade: revisao.nomeAtividade,
			}

			await Promise.all([this.buscarPerfisPorAtividadeFluxo(), this.buscarProximasAtivividadesFluxo()])

			this.perfil = {
				id: revisao.idPerfil,
				nome: revisao.nomePerfil,
			}
			this.encaminhamentoAutomatico = revisao.encaminhamentoAutomatico
			this.atividadeEncaminhamento = {
				id: revisao.idAtividadeEncaminhamento,
				nome: revisao.nomeAtividadeEncaminhamento,
			}
			this.idExternoModeloDocumento = revisao.idExternoModeloDocumento
			this.tipoDocumento = revisao.tipoDocumento
			this.tituloDocumento = revisao.tituloDocumento
			this.situacao = revisao.situacao
		},
		async buscarRevisaoPorId() {
			const revisao = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.REVISOES.BUSCAR_REVISAO_POR_ID,
				this.idRevisao,
			)
			this.setFormRevisao(revisao)
		},
		async buscarAtividadesFluxo() {
			const atividadesPorEntidade = {
				ADESAO: 'atividadesAdesao',
				ADESAO_EXTERNA: 'atividadesAdesaoExterna',
				PEDIDO_UTILIZACAO: 'atividadesPedido',
			}

			const { itens } = await this.$store.dispatch(actionTypes.ATA.BUSCAR_ATIVIDADES_FILTRO)

			this.atividadeDatasource = itens[0][atividadesPorEntidade[this.tipoEntidade]]
		},
		async onSelectTipoEntidade() {
			this.atividade = null
			this.atividadeDatasource = []

			this.perfil = null
			this.perfilDatasource = []

			this.atividadeEncaminhamento = null
			this.atividadeEncaminhamentoDatasource = []

			if (this.tipoEntidade) {
				await this.buscarAtividadesFluxo()
			}
		},
		async onSelectAtividadeFluxo() {
			this.perfil = null
			this.perfilDatasource = []

			this.atividadeEncaminhamento = null
			this.atividadeEncaminhamentoDatasource = []

			if (this.atividade) {
				await Promise.all([this.buscarPerfisPorAtividadeFluxo(), this.buscarProximasAtivividadesFluxo()])
			}
		},
		async buscarPerfisPorAtividadeFluxo() {
			const { itens } = await this.$store.dispatch(actionTypes.BPM.BUSCAR_LISTAGEM_PERFIL_POR_ATIVIDADE, {
				idProcessKey: this.processKey,
				idAtividade: this.atividade.idAtividade,
			})

			this.perfilDatasource = itens
		},
		async buscarProximasAtivividadesFluxo() {
			const { itens } = await this.$store.dispatch(actionTypes.BPM.BUSCAR_PROXIMAS_ATIVIDADES, {
				processKey: this.processKey,
				idAtividade: this.atividade.idAtividade,
			})

			this.atividadeEncaminhamentoDatasource = itens
		},
		async salvarRevisao() {
			if (this.visualizacao) return

			if (this.$refs.form.validate()) {
				const payload = {
					tipo: this.tipo,
					assinaturaAutomatica: this.assinaturaAutomatica,
					juntarAutomatico: this.juntarAutomatico,
					encaminhamentoAutomatico: this.encaminhamentoAutomatico,
					idAtividade: this.atividade.idAtividade,
					nomeAtividade: this.atividade.nomeAtividade,
					idAtividadeEncaminhamento: this.atividadeEncaminhamento?.id,
					nomeAtividadeEncaminhamento: this.atividadeEncaminhamento?.nome,
					idPerfil: this.perfil.id,
					nomePerfil: this.perfil.nome,
					tipoEntidade: this.tipoEntidade,
					idExternoModeloDocumento: this.idExternoModeloDocumento,
					tipoDocumento: this.tipoDocumento,
					tituloDocumento: this.tituloDocumento,
				}

				const revisao = await this.funcaoSalvarRevisao(payload)

				if (this.idRevisao) this.setFormRevisao(revisao)
			}
		},
		abrirFecharModalModeloDocumentoRevisao() {
			this.exibirModalModeloDocumentoRevisao = !this.exibirModalModeloDocumentoRevisao
		},
		abrirOuFecharModalConfirmacaoExcluirModelo() {
			this.exibirModalConfirmacaoExcluirModelo = !this.exibirModalConfirmacaoExcluirModelo
		},
		async salvarModeloDocumentoRevisao(tituloDocumento) {
			if (this.visualizacao) return

			await this.salvarRevisao()

			const { urlEdicao } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.SALVAR_MODELO_DOCUMENTO_REVISAO,
				{
					idRevisao: this.idRevisao,
					body: {
						titulo: tituloDocumento,
					},
				},
			)

			this.abrirFecharModalModeloDocumentoRevisao()
			this.redirecionarPara(urlEdicao)

			await this.buscarRevisaoPorId()
		},
		async redigirModeloDocumentoRevisao() {
			const { urlEdicao } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.REDIGIR_MODELO_DOCUMENTO_REVISAO,
				this.idRevisao,
			)

			this.redirecionarPara(urlEdicao)
		},
		async visualizarModeloDocumentoRevisao() {
			const { url } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.VISUALIZAR_MODELO_DOCUMENTO_REVISAO,
				this.idRevisao,
			)

			this.redirecionarPara(url)
		},
		async excluirModeloDocumentoRevisao() {
			await this.$store.dispatch(
				actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.REMOVER_MODELO_DOCUMENTO_REVISAO,
				this.idRevisao,
			)

			await this.buscarRevisaoPorId()
			this.abrirOuFecharModalConfirmacaoExcluirModelo()
			this.mostrarNotificacaoSucessoDefault()
		},
		async finalizarRevisao() {
			await this.salvarRevisao()

			await this.$store.dispatch(actionTypes.CONFIGURACAO.REVISOES.ALTERAR_SITUACAO_REVISAO, {
				idRevisao: this.idRevisao,
				body: {
					situacao: situacoesRevisao.FINALIZADO.value,
				},
			})
			this.mostrarNotificacaoSucessoDefault()
			await this.$router.push({ name: routesNames.CONFIGURACAO.REVISOES.REVISOES_VIEW })
		},
	},
}
</script>
